// extracted by mini-css-extract-plugin
module.exports = {"starFilterContainer":"FilterStars_starFilterContainer__FjNas"};